





















import {myVue} from "@/components/class/myVue";
import {Component } from 'vue-property-decorator';
@Component
export default class HelloWorld extends myVue {
}
